import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { CONFIG } from 'src/app/dataModels/config';

import { HelperService } from 'src/app/services/utils/helper.service';
import {
  CONSTANTS,
  COMPONENTS,
  ADDRESS_TYPE,
  PHONE_TYPE,
  EMAIL_TYPE,
  OPERATION,
  LOV_PROPERTIES,
  TABLE_SORT_ORDER,
  SORT_TYPE,
  TABLE_CELL_WIDTH,
} from 'src/app/dataModels/constants';
import { CompAccessService } from 'src/app/services/compAccess/comp-access.service';
import { ResourceManagerService } from 'src/app/services/resourceManager/resource-manager.service';
import { LOV_KEYS } from 'src/app/dataModels/lovs'; 
import { lastValueFrom } from 'rxjs';
import { firstValueFrom } from 'rxjs';
import { LoadingService } from '../shared/app-loading/loading.service';

/**
 * Monkeypox Service
 */
@Injectable({
  providedIn: 'root'
})
export class MonkeypoxService {
    /**
   * Profile List to be excluded from Facility Users
   */
    //  excludedProfileList = ['VFC ADMIN', 'SUPER ADMIN', 'TRAINER', 'QA', 'CDS USER', 'GENERAL'];


  constructor(
    private apiService: ApiService,
    private helperService: HelperService,
    private loadingService: LoadingService,
    private compAccessService: CompAccessService,
    private resourceManagerService: ResourceManagerService
 ) {}

/**
 * Get getMonkeyPoxProviderAgreement
 * @param facilityId Facility ID for which monkeypox agreement should be retrieved. 
 * @param status Monkeypox agreement status 'ACTIVE' or 'ARCHIVE'
 */
 async getMonkeyPoxProviderAgreement(facilityId, status) {
  const request = {
    objects: [
      {
        name: OPERATION.MONKEYPOX.GET_PROVIDER_AGREEMENT,
        params: {
          facilityId,
          status,
        },
      },
    ],
  };

  let existingMPAgreement = []; 

  const result = await firstValueFrom(this.apiService.post(CONFIG.MONKEYPOX_GETBUNDLE,request)); 

  if (this.helperService.isValidGetResult(result) && result.objects[0].json?.length > 0) {
    return result;
  }
  return existingMPAgreement;
 }


 async submitMonkeypoxAgreement(request ) {
 
     const result = await lastValueFrom(this.apiService.post(CONFIG.MONKEYPOX_MANAGE_PROV_AGMT,request));
  
     return result
}
 /**
   * check access
   */
  async checkAccess() {
    return this.compAccessService.checkAccess(['MONKEYPOX AGREEMENT']);
  }

}
